import { render } from "./SelfStudy.vue?vue&type=template&id=29ffa9a2&scoped=true"
import script from "./SelfStudy.vue?vue&type=script&lang=js"
export * from "./SelfStudy.vue?vue&type=script&lang=js"

import "./SelfStudy.vue?vue&type=style&index=0&id=29ffa9a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ffa9a2"]])

export default __exports__